export const spotify = '/spotify'
export const playlists = '/playlists'
export const campaignsList = '/campaigns'
export const confirmed = '/confirmed'
export const confirmEmail = '/confirmed'
export const createCampaign = '/new'
export const trackSubmitted = '/created'
export const scheduleCampaign = '/schedule'
export const reviews = '/reviews'
export const tracksFeed = '/tracksFeed'
export const balance = '/balance'
export const root = '/'
export const login = '/login'
export const signUpCreator = '/signup-creator'
export const signUpArtist = '/signup-artist'
export const signUpCurator = '/signup-curator'
export const forgotPass = '/forgot-password'
export const checkout = '/checkout'
export const campaignResults = '/view'
export const settings = '/settings'
export const rank = '/rank'
export const reset = '/reset-password'
export const submitted = '/submitted'
export const details = '/details'
export const create = '/create'
export const review = '/review'
export const completed = '/completed'
export const admin = '/admin/management'
export const analytics = '/analytics'
export const artists = '/artists'
export const curators = '/curators'
export const errors = '/errors'
export const register = '/register'
export const influencerBoard = '/influencer'
export const internalServerError = '/internal-server-error'
